import { render, staticRenderFns } from "./NewCommunicationForm.vue?vue&type=template&id=61ca0a0f&scoped=true"
import script from "./NewCommunicationForm.vue?vue&type=script&lang=js"
export * from "./NewCommunicationForm.vue?vue&type=script&lang=js"
import style0 from "./NewCommunicationForm.vue?vue&type=style&index=0&id=61ca0a0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ca0a0f",
  null
  
)

export default component.exports